import { CartAddEvent } from '@theme/events';
import { fetchConfig } from '@theme/utilities';

/**
 * RIVELLA sepet önerileri: [data-rv-add] düğmesi ürünü sepete ekler ve
 * sepet çekmecesini/sayfasını temanın kendi CartAddEvent akışıyla yeniler.
 */
async function rvAddToCart(button) {
  const variantId = button.dataset.rvAdd;
  if (!variantId || button.getAttribute('aria-busy') === 'true') return;

  const label = button.textContent;
  button.setAttribute('aria-busy', 'true');
  button.disabled = true;
  button.textContent = 'Ekleniyor…';

  const formData = new FormData();
  formData.append('id', variantId);
  formData.append('quantity', '1');

  const sectionIds = [];
  document.querySelectorAll('cart-items-component').forEach((el) => {
    if (el instanceof HTMLElement && el.dataset.sectionId) sectionIds.push(el.dataset.sectionId);
  });
  if (sectionIds.length) formData.append('sections', sectionIds.join(','));

  try {
    const cfg = fetchConfig('javascript', { body: formData });
    const response = await fetch(Theme.routes.cart_add_url, {
      ...cfg,
      headers: { ...cfg.headers, Accept: 'text/html' },
    });
    const data = await response.json();
    if (data.status) throw new Error(data.description || data.message || 'Sepete eklenemedi');

    let cart;
    try {
      cart = await fetch('/cart.js').then((r) => r.json());
    } catch (e) {
      cart = undefined;
    }

    document.dispatchEvent(
      new CartAddEvent(cart, variantId, {
        source: 'rv-cart-boost',
        itemCount: 1,
        productId: button.dataset.productId,
        sections: data.sections,
      })
    );
  } catch (error) {
    console.error('[RIVELLA] Sepete ekleme hatası', error);
    button.textContent = 'Eklenemedi';
    setTimeout(() => {
      button.textContent = label;
      button.disabled = false;
      button.removeAttribute('aria-busy');
    }, 2000);
  }
}

if (!window.__rvCartBoostReady) {
  window.__rvCartBoostReady = true;
  document.addEventListener('click', (event) => {
    const target = event.target instanceof Element ? event.target.closest('[data-rv-add]') : null;
    if (!(target instanceof HTMLButtonElement)) return;
    event.preventDefault();
    rvAddToCart(target);
  });
}
